module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Pen-tool-vector-4bbe0b00b51b2f512a4cf2f7fdd4b724.svg";